

const ChartIcon = ()=>{
    return(
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="15.000000pt" height="17.000000pt" viewBox="0 0 24.000000 24.000000"
        preserveAspectRatio="xMidYMid meet">
       
       <g transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
       fill="#000000" stroke="none">
       <path d="M42 128 l3 -83 83 -3 c52 -2 82 1 82 8 0 6 -30 10 -75 10 l-75 0 0
       75 c0 45 -4 75 -10 75 -7 0 -10 -30 -8 -82z"/>
       <path d="M178 163 c-14 -14 -20 -14 -33 -3 -14 11 -20 10 -43 -13 -29 -30 -23
       -50 8 -22 16 15 22 16 35 5 13 -11 20 -9 40 10 25 23 32 40 17 40 -4 0 -15 -7
       -24 -17z"/>
       </g>
       </svg>
    )
}

export default ChartIcon